/* eslint-disable no-console */
// Filtro de warnings/errors do console. Suprime mensagens conhecidas
// vindas de bugs em libs de terceiros que nao temos como corrigir
// no codigo da aplicacao (ja reportadas upstream ou descontinuadas).
//
// Manter este filtro pequeno e bem documentado — cada padrao tem um
// motivo explicito. Quando um upgrade da lib resolver, basta remover
// o padrao daqui.

// Padroes de mensagens a suprimir (substring match, case-sensitive).
const SUPPRESSED_PATTERNS = [
  // Recharts 1.x bug: propTypes do <Line> valida 'points[0].value' como
  // funcao (incorreto na lib). Aparece em todo render do LineChart.
  // Issue conhecido, projeto ainda nao foi pra recharts 2.x.
  'Line: prop type `points[0].value` is invalid',

  // Recharts 1.x: <PieChart> e <Pie> usam componentWillReceiveProps
  // (lifecycle deprecated em React 16.3+). React mostra warning em
  // dev. Bug upstream — sera resolvido com upgrade pra recharts 2.x.
  // Mensagem do React:
  //   "componentWillReceiveProps has been renamed... Please update
  //   the following components: PieChart" (e Pie)
  'componentWillReceiveProps has been renamed',

  // google-maps-react usa google.maps.Marker (deprecated em
  // fev/2024 em favor de AdvancedMarkerElement). Lib nao tem suporte
  // ao novo API. Migracao requer trocar de lib OU implementar
  // markers manualmente — fora de escopo no momento. Marker continua
  // funcionando, so e warning.
  'google.maps.Marker is deprecated',

  // Google Maps JS API loadou sem 'loading=async'. Lib google-maps-
  // react gerencia o carregamento e nao expoe a opcao. Bug upstream
  // sem fix possivel no nosso codigo.
  'Google Maps JavaScript API has been loaded directly without loading=async',
];

const shouldSuppress = (args) => {
  if (!args || !args.length) return false;
  // React/PropTypes formata args como [template, ...substitutions].
  // O primeiro arg geralmente e o template completo com placeholders
  // ja substituidos. Verificamos string match em qualquer arg.
  return args.some((arg) => {
    if (typeof arg !== 'string') return false;
    return SUPPRESSED_PATTERNS.some((pattern) => arg.includes(pattern));
  });
};

// Wrappa console.error preservando referencia original — chama o
// original SO se nao for uma mensagem suprimida.
const originalError = console.error;
console.error = (...args) => {
  if (shouldSuppress(args)) return;
  originalError.apply(console, args);
};

const originalWarn = console.warn;
console.warn = (...args) => {
  if (shouldSuppress(args)) return;
  originalWarn.apply(console, args);
};

// Export pra debug — permite checar quais padroes estao ativos.
export const getSuppressedPatterns = () => [...SUPPRESSED_PATTERNS];
